const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "red",
  "orange",
  "amber",
  "yellow",
  "green",
  "emerald",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle",
  "ghost",
  "link"
] as const

const size = [
  "xs",
  "sm",
  "md",
  "lg",
  "xl"
] as const

export default {
  "slots": {
    "base": [
      "rounded-md font-medium inline-flex items-center disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75",
      "transition-colors"
    ],
    "label": "truncate",
    "leadingIcon": "shrink-0",
    "leadingAvatar": "shrink-0",
    "leadingAvatarSize": "",
    "trailingIcon": "shrink-0"
  },
  "variants": {
    "fieldGroup": {
      "horizontal": "not-only:first:rounded-e-none not-only:last:rounded-s-none not-last:not-first:rounded-none focus-visible:z-[1]",
      "vertical": "not-only:first:rounded-b-none not-only:last:rounded-t-none not-last:not-first:rounded-none focus-visible:z-[1]"
    },
    "color": {
      "primary": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "red": "",
      "orange": "",
      "amber": "",
      "yellow": "",
      "green": "",
      "emerald": "",
      "teal": "",
      "cyan": "",
      "blue": "",
      "indigo": "",
      "purple": "",
      "pink": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": "",
      "ghost": "",
      "link": ""
    },
    "size": {
      "xs": {
        "base": "px-2 py-1 text-xs gap-1",
        "leadingIcon": "size-4",
        "leadingAvatarSize": "3xs",
        "trailingIcon": "size-4"
      },
      "sm": {
        "base": "px-2.5 py-1.5 text-xs gap-1.5",
        "leadingIcon": "size-4",
        "leadingAvatarSize": "3xs",
        "trailingIcon": "size-4"
      },
      "md": {
        "base": "px-2.5 py-1.5 text-sm gap-1.5",
        "leadingIcon": "size-5",
        "leadingAvatarSize": "2xs",
        "trailingIcon": "size-5"
      },
      "lg": {
        "base": "px-3 py-2 text-sm gap-2",
        "leadingIcon": "size-5",
        "leadingAvatarSize": "2xs",
        "trailingIcon": "size-5"
      },
      "xl": {
        "base": "px-3 py-2 text-base gap-2",
        "leadingIcon": "size-6",
        "leadingAvatarSize": "xs",
        "trailingIcon": "size-6"
      }
    },
    "block": {
      "true": {
        "base": "w-full justify-center",
        "trailingIcon": "ms-auto"
      }
    },
    "square": {
      "true": ""
    },
    "leading": {
      "true": ""
    },
    "trailing": {
      "true": ""
    },
    "loading": {
      "true": ""
    },
    "active": {
      "true": {
        "base": ""
      },
      "false": {
        "base": ""
      }
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-primary hover:bg-primary/75 active:bg-primary/75 disabled:bg-primary aria-disabled:bg-primary outline-primary/25 focus-visible:outline-3"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-secondary hover:bg-secondary/75 active:bg-secondary/75 disabled:bg-secondary aria-disabled:bg-secondary outline-secondary/25 focus-visible:outline-3"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-success hover:bg-success/75 active:bg-success/75 disabled:bg-success aria-disabled:bg-success outline-success/25 focus-visible:outline-3"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-info hover:bg-info/75 active:bg-info/75 disabled:bg-info aria-disabled:bg-info outline-info/25 focus-visible:outline-3"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-warning hover:bg-warning/75 active:bg-warning/75 disabled:bg-warning aria-disabled:bg-warning outline-warning/25 focus-visible:outline-3"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-error hover:bg-error/75 active:bg-error/75 disabled:bg-error aria-disabled:bg-error outline-error/25 focus-visible:outline-3"
    },
    {
      "color": "red" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-red hover:bg-red/75 active:bg-red/75 disabled:bg-red aria-disabled:bg-red outline-red/25 focus-visible:outline-3"
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-orange hover:bg-orange/75 active:bg-orange/75 disabled:bg-orange aria-disabled:bg-orange outline-orange/25 focus-visible:outline-3"
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-amber hover:bg-amber/75 active:bg-amber/75 disabled:bg-amber aria-disabled:bg-amber outline-amber/25 focus-visible:outline-3"
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-yellow hover:bg-yellow/75 active:bg-yellow/75 disabled:bg-yellow aria-disabled:bg-yellow outline-yellow/25 focus-visible:outline-3"
    },
    {
      "color": "green" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-green hover:bg-green/75 active:bg-green/75 disabled:bg-green aria-disabled:bg-green outline-green/25 focus-visible:outline-3"
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-emerald hover:bg-emerald/75 active:bg-emerald/75 disabled:bg-emerald aria-disabled:bg-emerald outline-emerald/25 focus-visible:outline-3"
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-teal hover:bg-teal/75 active:bg-teal/75 disabled:bg-teal aria-disabled:bg-teal outline-teal/25 focus-visible:outline-3"
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-cyan hover:bg-cyan/75 active:bg-cyan/75 disabled:bg-cyan aria-disabled:bg-cyan outline-cyan/25 focus-visible:outline-3"
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-blue hover:bg-blue/75 active:bg-blue/75 disabled:bg-blue aria-disabled:bg-blue outline-blue/25 focus-visible:outline-3"
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-indigo hover:bg-indigo/75 active:bg-indigo/75 disabled:bg-indigo aria-disabled:bg-indigo outline-indigo/25 focus-visible:outline-3"
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-purple hover:bg-purple/75 active:bg-purple/75 disabled:bg-purple aria-disabled:bg-purple outline-purple/25 focus-visible:outline-3"
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-pink hover:bg-pink/75 active:bg-pink/75 disabled:bg-pink aria-disabled:bg-pink outline-pink/25 focus-visible:outline-3"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-primary/50 text-primary hover:bg-primary/10 active:bg-primary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-secondary/50 text-secondary hover:bg-secondary/10 active:bg-secondary/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-success/50 text-success hover:bg-success/10 active:bg-success/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-info/50 text-info hover:bg-info/10 active:bg-info/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-warning/50 text-warning hover:bg-warning/10 active:bg-warning/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-error/50 text-error hover:bg-error/10 active:bg-error/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
    },
    {
      "color": "red" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-red/50 text-red hover:bg-red/10 active:bg-red/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-red/25 focus-visible:outline-3 focus-visible:ring-red"
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-orange/50 text-orange hover:bg-orange/10 active:bg-orange/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-orange/25 focus-visible:outline-3 focus-visible:ring-orange"
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-amber/50 text-amber hover:bg-amber/10 active:bg-amber/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-amber/25 focus-visible:outline-3 focus-visible:ring-amber"
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-yellow/50 text-yellow hover:bg-yellow/10 active:bg-yellow/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-yellow/25 focus-visible:outline-3 focus-visible:ring-yellow"
    },
    {
      "color": "green" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-green/50 text-green hover:bg-green/10 active:bg-green/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-green/25 focus-visible:outline-3 focus-visible:ring-green"
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-emerald/50 text-emerald hover:bg-emerald/10 active:bg-emerald/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-emerald/25 focus-visible:outline-3 focus-visible:ring-emerald"
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-teal/50 text-teal hover:bg-teal/10 active:bg-teal/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-teal/25 focus-visible:outline-3 focus-visible:ring-teal"
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-cyan/50 text-cyan hover:bg-cyan/10 active:bg-cyan/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-cyan/25 focus-visible:outline-3 focus-visible:ring-cyan"
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-blue/50 text-blue hover:bg-blue/10 active:bg-blue/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-blue/25 focus-visible:outline-3 focus-visible:ring-blue"
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-indigo/50 text-indigo hover:bg-indigo/10 active:bg-indigo/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-indigo/25 focus-visible:outline-3 focus-visible:ring-indigo"
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-purple/50 text-purple hover:bg-purple/10 active:bg-purple/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-purple/25 focus-visible:outline-3 focus-visible:ring-purple"
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-pink/50 text-pink hover:bg-pink/10 active:bg-pink/10 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent outline-pink/25 focus-visible:outline-3 focus-visible:ring-pink"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-primary bg-primary/10 hover:bg-primary/15 active:bg-primary/15 outline-primary/25 focus-visible:outline-3 disabled:bg-primary/10 aria-disabled:bg-primary/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-secondary bg-secondary/10 hover:bg-secondary/15 active:bg-secondary/15 outline-secondary/25 focus-visible:outline-3 disabled:bg-secondary/10 aria-disabled:bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-success bg-success/10 hover:bg-success/15 active:bg-success/15 outline-success/25 focus-visible:outline-3 disabled:bg-success/10 aria-disabled:bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-info bg-info/10 hover:bg-info/15 active:bg-info/15 outline-info/25 focus-visible:outline-3 disabled:bg-info/10 aria-disabled:bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-warning bg-warning/10 hover:bg-warning/15 active:bg-warning/15 outline-warning/25 focus-visible:outline-3 disabled:bg-warning/10 aria-disabled:bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-error bg-error/10 hover:bg-error/15 active:bg-error/15 outline-error/25 focus-visible:outline-3 disabled:bg-error/10 aria-disabled:bg-error/10"
    },
    {
      "color": "red" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-red bg-red/10 hover:bg-red/15 active:bg-red/15 outline-red/25 focus-visible:outline-3 disabled:bg-red/10 aria-disabled:bg-red/10"
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-orange bg-orange/10 hover:bg-orange/15 active:bg-orange/15 outline-orange/25 focus-visible:outline-3 disabled:bg-orange/10 aria-disabled:bg-orange/10"
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-amber bg-amber/10 hover:bg-amber/15 active:bg-amber/15 outline-amber/25 focus-visible:outline-3 disabled:bg-amber/10 aria-disabled:bg-amber/10"
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-yellow bg-yellow/10 hover:bg-yellow/15 active:bg-yellow/15 outline-yellow/25 focus-visible:outline-3 disabled:bg-yellow/10 aria-disabled:bg-yellow/10"
    },
    {
      "color": "green" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-green bg-green/10 hover:bg-green/15 active:bg-green/15 outline-green/25 focus-visible:outline-3 disabled:bg-green/10 aria-disabled:bg-green/10"
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-emerald bg-emerald/10 hover:bg-emerald/15 active:bg-emerald/15 outline-emerald/25 focus-visible:outline-3 disabled:bg-emerald/10 aria-disabled:bg-emerald/10"
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-teal bg-teal/10 hover:bg-teal/15 active:bg-teal/15 outline-teal/25 focus-visible:outline-3 disabled:bg-teal/10 aria-disabled:bg-teal/10"
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-cyan bg-cyan/10 hover:bg-cyan/15 active:bg-cyan/15 outline-cyan/25 focus-visible:outline-3 disabled:bg-cyan/10 aria-disabled:bg-cyan/10"
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-blue bg-blue/10 hover:bg-blue/15 active:bg-blue/15 outline-blue/25 focus-visible:outline-3 disabled:bg-blue/10 aria-disabled:bg-blue/10"
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-indigo bg-indigo/10 hover:bg-indigo/15 active:bg-indigo/15 outline-indigo/25 focus-visible:outline-3 disabled:bg-indigo/10 aria-disabled:bg-indigo/10"
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-purple bg-purple/10 hover:bg-purple/15 active:bg-purple/15 outline-purple/25 focus-visible:outline-3 disabled:bg-purple/10 aria-disabled:bg-purple/10"
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-pink bg-pink/10 hover:bg-pink/15 active:bg-pink/15 outline-pink/25 focus-visible:outline-3 disabled:bg-pink/10 aria-disabled:bg-pink/10"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-primary ring ring-inset ring-primary/25 bg-primary/10 hover:bg-primary/15 active:bg-primary/15 disabled:bg-primary/10 aria-disabled:bg-primary/10 outline-primary/25 focus-visible:outline-3 focus-visible:ring-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-secondary ring ring-inset ring-secondary/25 bg-secondary/10 hover:bg-secondary/15 active:bg-secondary/15 disabled:bg-secondary/10 aria-disabled:bg-secondary/10 outline-secondary/25 focus-visible:outline-3 focus-visible:ring-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-success ring ring-inset ring-success/25 bg-success/10 hover:bg-success/15 active:bg-success/15 disabled:bg-success/10 aria-disabled:bg-success/10 outline-success/25 focus-visible:outline-3 focus-visible:ring-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-info ring ring-inset ring-info/25 bg-info/10 hover:bg-info/15 active:bg-info/15 disabled:bg-info/10 aria-disabled:bg-info/10 outline-info/25 focus-visible:outline-3 focus-visible:ring-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-warning ring ring-inset ring-warning/25 bg-warning/10 hover:bg-warning/15 active:bg-warning/15 disabled:bg-warning/10 aria-disabled:bg-warning/10 outline-warning/25 focus-visible:outline-3 focus-visible:ring-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-error ring ring-inset ring-error/25 bg-error/10 hover:bg-error/15 active:bg-error/15 disabled:bg-error/10 aria-disabled:bg-error/10 outline-error/25 focus-visible:outline-3 focus-visible:ring-error"
    },
    {
      "color": "red" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-red ring ring-inset ring-red/25 bg-red/10 hover:bg-red/15 active:bg-red/15 disabled:bg-red/10 aria-disabled:bg-red/10 outline-red/25 focus-visible:outline-3 focus-visible:ring-red"
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-orange ring ring-inset ring-orange/25 bg-orange/10 hover:bg-orange/15 active:bg-orange/15 disabled:bg-orange/10 aria-disabled:bg-orange/10 outline-orange/25 focus-visible:outline-3 focus-visible:ring-orange"
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-amber ring ring-inset ring-amber/25 bg-amber/10 hover:bg-amber/15 active:bg-amber/15 disabled:bg-amber/10 aria-disabled:bg-amber/10 outline-amber/25 focus-visible:outline-3 focus-visible:ring-amber"
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-yellow ring ring-inset ring-yellow/25 bg-yellow/10 hover:bg-yellow/15 active:bg-yellow/15 disabled:bg-yellow/10 aria-disabled:bg-yellow/10 outline-yellow/25 focus-visible:outline-3 focus-visible:ring-yellow"
    },
    {
      "color": "green" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-green ring ring-inset ring-green/25 bg-green/10 hover:bg-green/15 active:bg-green/15 disabled:bg-green/10 aria-disabled:bg-green/10 outline-green/25 focus-visible:outline-3 focus-visible:ring-green"
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-emerald ring ring-inset ring-emerald/25 bg-emerald/10 hover:bg-emerald/15 active:bg-emerald/15 disabled:bg-emerald/10 aria-disabled:bg-emerald/10 outline-emerald/25 focus-visible:outline-3 focus-visible:ring-emerald"
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-teal ring ring-inset ring-teal/25 bg-teal/10 hover:bg-teal/15 active:bg-teal/15 disabled:bg-teal/10 aria-disabled:bg-teal/10 outline-teal/25 focus-visible:outline-3 focus-visible:ring-teal"
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-cyan ring ring-inset ring-cyan/25 bg-cyan/10 hover:bg-cyan/15 active:bg-cyan/15 disabled:bg-cyan/10 aria-disabled:bg-cyan/10 outline-cyan/25 focus-visible:outline-3 focus-visible:ring-cyan"
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-blue ring ring-inset ring-blue/25 bg-blue/10 hover:bg-blue/15 active:bg-blue/15 disabled:bg-blue/10 aria-disabled:bg-blue/10 outline-blue/25 focus-visible:outline-3 focus-visible:ring-blue"
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-indigo ring ring-inset ring-indigo/25 bg-indigo/10 hover:bg-indigo/15 active:bg-indigo/15 disabled:bg-indigo/10 aria-disabled:bg-indigo/10 outline-indigo/25 focus-visible:outline-3 focus-visible:ring-indigo"
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-purple ring ring-inset ring-purple/25 bg-purple/10 hover:bg-purple/15 active:bg-purple/15 disabled:bg-purple/10 aria-disabled:bg-purple/10 outline-purple/25 focus-visible:outline-3 focus-visible:ring-purple"
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-pink ring ring-inset ring-pink/25 bg-pink/10 hover:bg-pink/15 active:bg-pink/15 disabled:bg-pink/10 aria-disabled:bg-pink/10 outline-pink/25 focus-visible:outline-3 focus-visible:ring-pink"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-primary hover:bg-primary/10 active:bg-primary/10 outline-primary/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-secondary hover:bg-secondary/10 active:bg-secondary/10 outline-secondary/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-success hover:bg-success/10 active:bg-success/10 outline-success/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-info hover:bg-info/10 active:bg-info/10 outline-info/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-warning hover:bg-warning/10 active:bg-warning/10 outline-warning/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-error hover:bg-error/10 active:bg-error/10 outline-error/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "red" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-red hover:bg-red/10 active:bg-red/10 outline-red/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-orange hover:bg-orange/10 active:bg-orange/10 outline-orange/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-amber hover:bg-amber/10 active:bg-amber/10 outline-amber/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-yellow hover:bg-yellow/10 active:bg-yellow/10 outline-yellow/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "green" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-green hover:bg-green/10 active:bg-green/10 outline-green/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-emerald hover:bg-emerald/10 active:bg-emerald/10 outline-emerald/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-teal hover:bg-teal/10 active:bg-teal/10 outline-teal/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-cyan hover:bg-cyan/10 active:bg-cyan/10 outline-cyan/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-blue hover:bg-blue/10 active:bg-blue/10 outline-blue/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-indigo hover:bg-indigo/10 active:bg-indigo/10 outline-indigo/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-purple hover:bg-purple/10 active:bg-purple/10 outline-purple/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-pink hover:bg-pink/10 active:bg-pink/10 outline-pink/25 focus-visible:outline-3 disabled:bg-transparent aria-disabled:bg-transparent dark:disabled:bg-transparent dark:aria-disabled:bg-transparent"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-primary hover:text-primary/75 active:text-primary/75 disabled:text-primary aria-disabled:text-primary outline-primary/25 focus-visible:outline-3"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-secondary hover:text-secondary/75 active:text-secondary/75 disabled:text-secondary aria-disabled:text-secondary outline-secondary/25 focus-visible:outline-3"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-success hover:text-success/75 active:text-success/75 disabled:text-success aria-disabled:text-success outline-success/25 focus-visible:outline-3"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-info hover:text-info/75 active:text-info/75 disabled:text-info aria-disabled:text-info outline-info/25 focus-visible:outline-3"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-warning hover:text-warning/75 active:text-warning/75 disabled:text-warning aria-disabled:text-warning outline-warning/25 focus-visible:outline-3"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-error hover:text-error/75 active:text-error/75 disabled:text-error aria-disabled:text-error outline-error/25 focus-visible:outline-3"
    },
    {
      "color": "red" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-red hover:text-red/75 active:text-red/75 disabled:text-red aria-disabled:text-red outline-red/25 focus-visible:outline-3"
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-orange hover:text-orange/75 active:text-orange/75 disabled:text-orange aria-disabled:text-orange outline-orange/25 focus-visible:outline-3"
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-amber hover:text-amber/75 active:text-amber/75 disabled:text-amber aria-disabled:text-amber outline-amber/25 focus-visible:outline-3"
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-yellow hover:text-yellow/75 active:text-yellow/75 disabled:text-yellow aria-disabled:text-yellow outline-yellow/25 focus-visible:outline-3"
    },
    {
      "color": "green" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-green hover:text-green/75 active:text-green/75 disabled:text-green aria-disabled:text-green outline-green/25 focus-visible:outline-3"
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-emerald hover:text-emerald/75 active:text-emerald/75 disabled:text-emerald aria-disabled:text-emerald outline-emerald/25 focus-visible:outline-3"
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-teal hover:text-teal/75 active:text-teal/75 disabled:text-teal aria-disabled:text-teal outline-teal/25 focus-visible:outline-3"
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-cyan hover:text-cyan/75 active:text-cyan/75 disabled:text-cyan aria-disabled:text-cyan outline-cyan/25 focus-visible:outline-3"
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-blue hover:text-blue/75 active:text-blue/75 disabled:text-blue aria-disabled:text-blue outline-blue/25 focus-visible:outline-3"
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-indigo hover:text-indigo/75 active:text-indigo/75 disabled:text-indigo aria-disabled:text-indigo outline-indigo/25 focus-visible:outline-3"
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-purple hover:text-purple/75 active:text-purple/75 disabled:text-purple aria-disabled:text-purple outline-purple/25 focus-visible:outline-3"
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-pink hover:text-pink/75 active:text-pink/75 disabled:text-pink aria-disabled:text-pink outline-pink/25 focus-visible:outline-3"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-inverted hover:bg-inverted/90 active:bg-inverted/90 disabled:bg-inverted aria-disabled:bg-inverted outline-inverted/25 focus-visible:outline-3"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-default hover:bg-elevated active:bg-elevated disabled:bg-default aria-disabled:bg-default outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-default bg-elevated hover:bg-accented/75 active:bg-accented/75 outline-inverted/25 focus-visible:outline-3 disabled:bg-elevated aria-disabled:bg-elevated"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-elevated hover:bg-accented/75 active:bg-accented/75 disabled:bg-elevated aria-disabled:bg-elevated outline-inverted/25 focus-visible:outline-3 focus-visible:ring-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "ghost" as typeof variant[number],
      "class": "text-default hover:bg-elevated active:bg-elevated outline-inverted/25 focus-visible:outline-3 hover:disabled:bg-transparent dark:hover:disabled:bg-transparent hover:aria-disabled:bg-transparent dark:hover:aria-disabled:bg-transparent"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "link" as typeof variant[number],
      "class": "text-muted hover:text-default active:text-default disabled:text-muted aria-disabled:text-muted outline-inverted/25 focus-visible:outline-3"
    },
    {
      "size": "xs" as typeof size[number],
      "square": true,
      "class": "p-1"
    },
    {
      "size": "sm" as typeof size[number],
      "square": true,
      "class": "p-1.5"
    },
    {
      "size": "md" as typeof size[number],
      "square": true,
      "class": "p-1.5"
    },
    {
      "size": "lg" as typeof size[number],
      "square": true,
      "class": "p-2"
    },
    {
      "size": "xl" as typeof size[number],
      "square": true,
      "class": "p-2"
    },
    {
      "loading": true,
      "leading": true,
      "class": {
        "leadingIcon": "animate-spin"
      }
    },
    {
      "loading": true,
      "leading": false,
      "trailing": true,
      "class": {
        "trailingIcon": "animate-spin"
      }
    }
  ],
  "defaultVariants": {
    "color": "primary" as typeof color[number],
    "variant": "solid" as typeof variant[number],
    "size": "md" as typeof size[number]
  }
}